import Head from "next/head";

import { ErrorBoundary } from "@/_app/components/ErrorBoundary";
import { AppProviders } from "@/_app/providers";
import { muiTheme } from "@/_app/styles/muiTheme";
import { ErrorHero } from "@/common/components/molecules/ErrorHero";
import { startBugsnag } from "@/common/utils/bugsnag";
import { AppLayout } from "@/layouts/AppLayout";
import { AppCacheProvider } from "@mui/material-nextjs/v16-pagesRouter";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

startBugsnag();

export default function MyApp(props) {
  const { Component, pageProps } = props;
  const { session, dehydratedState, errorCode, ...restPageProps } = pageProps;

  const getLayout = Component.getLayout ?? ((page) => <AppLayout>{page}</AppLayout>);

  return (
    <AppCacheProvider {...props}>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <AppProviders session={session} dehydratedState={dehydratedState}>
        <ThemeProvider theme={muiTheme}>
          <ErrorBoundary>
            <CssBaseline enableColorScheme />
            {!errorCode
              ? getLayout(<Component {...restPageProps} />)
              : getLayout(<ErrorHero variant={errorCode} />)}
          </ErrorBoundary>
        </ThemeProvider>
      </AppProviders>
    </AppCacheProvider>
  );
}
